export const wareHouseKey="transportation.warehoueDetails.id"
export const  placeKey="transportation.tradeTerms.place"
export const  typeIdKey="transportation.borderTransitMode.typeId"
export const depTypeIdKey="transportation.departureTransitMode.typeId"
export const postalCodeKey="transportation.goodsLocation.postalCode" 
export const  motKey="transportation.borderTransitMode.mot"
export const ducrKey="exitInfo.ducr"
export const destCountryKey="transportation.destinationCountry"
export const depMotKey="transportation.departureTransitMode.mot"
export const incotermKey="transportation.tradeTerms.incoTerms"
export const descriptionKey="transportation.tradeTerms.description"

const createPartiesPattern=()=>{
  let validationParties =  ["consignee", "agent", "declarant", "exporter"].reduce((prev,curr)=>{
    return {...prev, 
      [`${curr}.name`]:{
          presence:false,
          length: {
            maximum: 70,
            message:`^${curr} : Length of Name should be max 70 characters.`
          },
          format:{
            pattern:/^[a-zA-Z0-9., ]*$/,
            message:`^${curr} : Name can only contain alphanumeric, dot and comma characters.`
          }
      },
      [`${curr}.eoriNo`]: {
        presence:false,
        format:{
          pattern:/^[ ]$|[a-zA-Z]{2}[0-9]{9}$/,
          message:`^${curr} : EORI_NO, first 2 positions should be alphabet and remaining 9 should be numbers.`
        }
      },
      [`${curr}.addressLine1`]: {
        presence:false,        
        length: {
          maximum: 70,
          message:`^${curr} : Length of Address Line 1 should be max 70 characters.`
        },
        format:{
          pattern:/^[a-zA-Z0-9., ]*$/,
          message:`^${curr} : Address Line 1 can only contain alphanumeric, dot and comma characters.`
        }
      },
      [`${curr}.addressLine2`]: {
        presence:false,        
        length: {
          maximum: 70,
          message:`^${curr} : Length of Address Line 2 should be max 70 characters.`
        },
        format:{
          pattern:/^[a-zA-Z0-9., ]*$/,
          message:`^${curr} : Address Line 2 can only contain alphanumeric, dot and comma characters.`
        }
      },
      [`${curr}.city`]: {
        presence:false,        
        length: {
          maximum: 35,
          message:`^${curr} : Length of City should be max 35 characters.`
        },
        format:{
          pattern:/^[a-zA-Z0-9., ]*$/,
          message:`^${curr} : City can only contain alphanumeric, dot and comma characters.`
        }
      },
      // [`${curr}.state`]: {
      //   presence:false,        
      //   length: {
      //     maximum: 35,
      //     message:`^${curr} : Length of State should be max 35 characters.`
      //   },
      //   format:{
      //     pattern:/^[a-zA-Z0-9., ]*$/,
      //     message:`^${curr} : State can only contain alphanumeric, dot and comma characters.`
      //   }
      // },
      [`${curr}.postalCode`]: {
        presence:false,       
        length: {
          maximum: 9,
          message:`^${curr} : Length of Postal Code should be max 9 characters.`
        },
        format:{
          pattern:/^[a-zA-Z0-9 ]*$/,
          message:`^${curr} : Postal Code can only contain alphanumeric characters.`
        }
      },
    }
  },{})
  delete validationParties[`consignee.eoriNo`]
  return validationParties
}

export const NL_fieldPatterns =(isDms,isImportShipment)=>{
  if(isDms)
      return ()=>({
        header:{},
        parties:{},
        items:{
          invoice:()=>({}),
          lineItem:()=>({}),
          additionalDoc:()=>({}),
          prevDoc:()=>({})
        }
      })
  return (dependentParams={})=>({
    header: {
        [wareHouseKey]:{
            presence:false,  //{message:"^WAREHOUSE ID is mandatory",allowEmpty:false},
            length: {
              minimum: 0,
              maximum: 17,
              message:"^Length of WAREHOUSE ID should be from 10 to 17 digit"
            }
            // format: {
            //   pattern: /^([a-zA-Z0-9]+\s?)*.NL$/,
            //   message:"^WAREHOUSE ID should end with NL and can only contain A - Z, 0 - 9 and one space"
            // }
           
    },
    [placeKey]:{
        presence:(!dependentParams.isValueXXX || dependentParams.isValueXXX=="XXX") ? false :{message:"^PLACE is mandatory If value of INCOTERMS is other than XXX",allowEmpty:false},
        length: {
          maximum:256,
          message: "^max length of PLACE should be 256"
        }
},
    [typeIdKey]:{
      presence:false,
      length: {
        maximum:35,
        message: "^max length of BORDER TYPE ID should be 35"
      }
    },
    [depTypeIdKey]:{
      presence:(!dependentParams.mot || ["5","7"].includes(dependentParams.mot)) ? false :{message:"^DEPARTURE TYPE ID is mandatory",allowEmpty:false},
      length: {
        maximum:["5","7"].includes(dependentParams.mot) ? 0 : 27,
        message: ["5","7"].includes(dependentParams.mot) ? "^":"^max length of DEPARTURE TYPE ID should be 27"
      }
    
    },
    [postalCodeKey]:{
      presence:{message:"^POSTAL CODE is mandatory",allowEmpty:false},
      format: {
        pattern: "",
        message: function(value, attribute, validatorOptions, attributes, globalOptions) {
          const pattern=new RegExp(/\d{4}\s\w([A-Z])\s([a-zA-Z0-9]){5}$/)
          const msg="^POSTAL CODE can only contain:Position 1-4: numeric part. Position 5: space. Position 6-7:two uppercases(A2). Position 8: space. Position 9-13:alpha numeric. Position 14: space. Positions 15-35 are optional.Example: 9999 ZZ 99999 LOODSNR.12"
          if(value?.length<=13){
            if(!(pattern).test(value))
                return msg
             return "^"
          }
          else if(!(new RegExp(/\d{4}\s\w([A-Z])\s([a-zA-Z0-9]){5}\s([a-zA-Z0-9\.\s]){1,21}$/)).test(value))
              return msg
          else
             return "^"
          
          }
        }
    },
    [ducrKey]:{
      presence:{message:"^DUCR is mandatory",allowEmpty:false},
      length: {
        maximum:22,
        message: "^max length of DUCR should be 22"
      }
    
    },
    [destCountryKey]:{
      presence:{message:"^DESTINATION COUNTRY is mandatory",allowEmpty:false},
    },
    [depMotKey]:{
      presence:!dependentParams.mot && dependentParams?.customsOffice?.some(c=>c.type=="EXT" && !c.office?.startsWith('NL')) ? {message:"^If Customs office of exit (Type EXT) doesn't start with NL then DEPARTURE TRANSIT MODE is required",allowEmpty:false} : false
    },
    [incotermKey]:{
      presence:{message:"^INCOTERMS is mandatory",allowEmpty:false}
    },
    [descriptionKey]:{
      presence:dependentParams.isValueXXX=="XXX" ? {message:"^DESCRIPTION is mandatory If value of INCOTERMS is XXX",allowEmpty:false}:false,
      length: {
        maximum:70,
        message: "^max length of DESCRIPTION should be 70"
      }
    }
    },
    parties:createPartiesPattern(),
    valueBuildUp: {
      shipmentCostType: {
        costType: {
          presence:{ message:"Cost Type is mandatory",allowEmpty:false}
        }
      }
    },
    items: {
      invoice: (idx)=>({
        invoiceNum: {
            presence: { message: `^${idx ?`Invoice 00${idx} :: `:""} INVOICE_NUMBER is mandatory`, allowEmpty: false },
            // format: {
            //     pattern: /^[a-zA-Z0-9 -]*$/,
            //     message: `^${idx ?`Invoice 00${idx} :: `:""} INVOICE_NUMBER can only contain alphanumeric, space and hyphen characters.`
            // },
            length: {
              maximum: 35,
              message: `^${idx ?`Invoice 00${idx} :: `:""} max length of INVOICE_NUMBER should be 35`
            }
        },
        poNumber: {
          presence:false,
          length: {
            maximum: 20,
            message: `^${idx ?`Invoice 00${idx} :: `:""} max length of PO_NUM should be 20`
          },
        },
        invoiceEpoch: {
            presence: { message: `^${idx ?`Invoice 00${idx} :: `:""} INVOICE_DATE is mandatory`, allowEmpty: false },
        },
        currencyCode: {
          presence: {allowEmpty: false, message: `^${idx ?`Invoice 00${idx} :: `:""} CURRENCY_CODE is mandatory`, }
        },
        exchRate: {
          presence: {allowEmpty: false, message: `^${idx ?`Invoice 00${idx} :: `:""} EXCHANGE_RATE is mandatory`, },
          format: {
            pattern: /^(?=.*[1-9])\d*\.?\d*$/,
            message: `^${idx ?`Invoice 00${idx} :: `:""} EXCHANGE_RATE can't be zero.`
          }
        },
      }),
      lineItem: (inIdx, liIdx)=>({
        goodsDescription:{ 
          presence: {allowEmpty: false, message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` :""} GOODS_DESCRIPTION is mandatory` }, 
          format: {
            pattern: /^[a-zA-Z0-9-.,| ]*$/,
            message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} GOODS_DESCRIPTION can only contain alphanumeric, space, dot, comma, pipe and hyphen characters.`
          },
          length: {
            maximum: 255,
            message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} max length of GOODS_DESCRIPTION should be 255`
          }
        },
        sku:{
          presence: false,
          format: {
            pattern: /^[a-zA-Z0-9 ]*$/,
            message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} SKU can only contain alphanumeric and space characters.`
          },
          length: {
            maximum: 30,
            message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} max length of SKU should be 30`
          }
        },
        commodity: {
          presence: {allowEmpty: false, message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` :""} HTS_CODE is mandatory` },
          length: {
            minimum: dependentParams?.isImportShipment ? 10 : 8,
            maximum: dependentParams?.isImportShipment ? 10 : 8,
            message:`^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` :""} max length of HTS Code should be ${dependentParams?.isImportShipment ? '10' : '8'}`
          }
        },
        procedure:{          
          presence: {allowEmpty: false, message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` :""} PROCEDURE is mandatory` }
        }, 
        origin: {
          presence: {allowEmpty: false, message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` :""} ORIGIN is mandatory` }
        },
        weightUoM:{
          presence:false
        }, 
        supplyUnit: (value, attributes)=>{
          return { 
            presence: (attributes?.weightUoM && !isImportShipment) ? {
              allowEmpty:false, 
              message:`^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} if UOM is present then SUPPLY_UNIT is mandatory`
            }: false,
            length: {
              maximum: 9,
              message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} max length of SUPPLY_UNIT should be 9`
            }
        }
      },     
        invoiceVal:{
          presence: {allowEmpty: false, message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` :""} INVOICE_VAL is mandatory` },
          format: {
            pattern: /^[0-9]{0,16}(?:\.[0-9]{0,2})?$/,
            message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} INVOICE_VAL can only contain numeric values with max 16 digit and 2 decimal digits.`
          }
        },
        grossWeightQty:{
          presence: {allowEmpty: false, message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` :""} GROSS_WEIGHT is mandatory` },
          format: {
            pattern: /^[0-9]{0,11}(?:\.[0-9]{0,3})?$/,
            message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} GROSS_WEIGHT can only contain numeric values with max 11 digit and 3 decimal digits.`
          }
        },
        netWeightQty:{
          presence: {allowEmpty: false, message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` :""} NET_MASS is mandatory` },
          format: {
            pattern: /^[0-9]{0,11}(?:\.[0-9]{0,3})?$/,
            message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} NET_MASS can only contain numeric values with max 11 digit and 3 decimal digits.`
          }
        },
        pkgType : {
          presence: {allowEmpty: false, message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` :""} PKG_TYPE is mandatory` },
        },
        pkgQty: {
          presence: {allowEmpty: false, message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` :""} #PACKAGES is mandatory` },
          format: {
            pattern: /^[0-9]*$/,
            message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} #PACKAGES can only contain numeric values.`
          },
          length: {
            maximum: 9,
            message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} max length of #PACKAGES should be 9.`
          }
        },
        shippingMark: (value, attributes)=>{
          return {
            presence: !(['VL','VO','VQ','VR','VS','VY','NE','NF','NG'].includes(attributes?.pkgType)) ? {
              allowEmpty:false, 
              message:`^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} if PKG_TYPE is not VL, VO, VQ, VR, VS, VY, NE, NF or NG then SHIP_MARK is mandatory`
            }:false,
            format: {
              pattern: /^[a-zA-Z0-9 ]*$/,
              message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} SHIP_MARK can only contain alphanumeric and space characters.`
            },
            length: {
              maximum: 42,
              message: `^${(inIdx && liIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: `:""} max length of SHIP_MARK should be 42`
            }
          }
        }
      }),
      additionalDoc: (inIdx, liIdx, aiIdx) => ({
        ref:{
          presence: false,
          format: {
            pattern: /^[a-zA-Z0-9]*$/,
            message: `^${(inIdx && liIdx && aiIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: Additional Doc 00${aiIdx} ::`:""} REF can only contain alphanumeric characters.`
          },
          length: {
            maximum: 35,
            message: `^${(inIdx && liIdx && aiIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: Additional Doc 00${aiIdx} :: `:""} max length of REF should be 35`
          }
        },
        amount:{
          presence:false,
          format: {
            pattern: /^[0-9]{0,16}(?:\.[0-9]{0,2})?$/,
            message: `^${(inIdx && liIdx && aiIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: Additional Doc 00${aiIdx} :: `:""} AMOUNT can only contain numeric values with max 16 digit and 2 decimal digits.`
          }
        },
        currency: (value, attributes) => {
            return {presence : (attributes?.amount)? {
              allowEmpty:false, message: `^${(inIdx && liIdx && aiIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: Additional Doc 00${aiIdx} :: `:""} if AMOUNT is complete then CURRENCY cannot be empty.`
            }:false}
        },
        quantity:{
          presence:false,
          format: {
            pattern: /^[0-9]{0,16}?$/,
            message: `^${(inIdx && liIdx && aiIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: Additional Doc 00${aiIdx} :: `:""} QTY can only contain numeric values with max 16 digits.`
          }
        },
        uom:(value, attributes) => {
          return {presence : (attributes?.quantity)? {
            allowEmpty:false, message: `^${(inIdx && liIdx && aiIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: Additional Doc 00${aiIdx} :: `:""} if QTY is complete then UOM cannot be empty.`
          }:false}
        }
      }),
      prevDoc:(inIdx, liIdx, pdIdx)=>({
        docType: {
          presence: false
        },
        line:(value, attributes) => {
          return {
              presence : (attributes?.docType == 'N705')? {
              allowEmpty:false, message: `^${(inIdx && liIdx && pdIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: Previous Document 00${pdIdx} :: `:""} LINE is mandatory.`
            }:false,
            length: {
              maximum: 4,
              message: `^${(inIdx && liIdx && pdIdx) ?`Invoice 00${inIdx} :: LineItem 00${liIdx} :: Previous Document 00${pdIdx} :: `:""} max length of LINE should be 4`
            }
          }
        }
      })
    }
  
  })
}
